import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useQuery } from '@apollo/client/react';
import { FormattedMessage } from 'react-intl';
import { TemplatesLink } from 'utils/link';
import { useError } from 'contexts/error';
import { BreadCrumbLink } from 'components/styles_components/link';
import { BreadCrumbTypography } from 'components/styles_components/typography';
import TemplateQuery from 'queries/template/show';
import ShowItem from 'components/template/show_item';
import Loader from 'components/loader';
import BreadcrumbContainer from 'components/breadcrumb_container';
import Container from 'components/layout/container';

const Template = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const setError = useError();
  const {
    data = { template: { templateFields: [] }, space: { adminRole: true } },
    loading,
    error,
    refetch,
  } = useQuery(TemplateQuery, {
    variables: { id },
    onError: () => {
      setError('error.template.show');
      navigate(TemplatesLink());
    },
  });
  if (loading || error) {
    return <Loader />;
  }

  return (
    <Container>
      <BreadcrumbContainer>
        <BreadCrumbLink to={TemplatesLink()}>
          <FormattedMessage id="breadcrumb.template.index" />
        </BreadCrumbLink>
        <BreadCrumbTypography>{data.template.name}</BreadCrumbTypography>
      </BreadcrumbContainer>
      <ShowItem template={data.template} space={data.space} refetch={refetch} />
    </Container>
  );
};

export default Template;
